
export const environment = {
  production: true,
  API_URL: "https://3pyitx2pzf.us-east-1.awsapprunner.com",
  CLUSTER_SCHEDULE_SLIDE_INTERVAL: "undefined"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts